
import PropTypes from 'prop-types';
import { Drawer, Space } from "antd";
import { CancelIcon } from '../../../../components/Icons/Icons';
import CustomHtmlParser from '../../Email/CustomHtmlParser'

const NoteDetails = ({ openIntelligence, openTacking, researchContent }) => {
    return (
        <><Drawer
            className='Drawer-Header-Pages'
            bodyStyle={{ padding: "0px 20px" }}
            title="Account Intelligence Report"
            closable={false}
            placement="right"
            open={openIntelligence}
            width="80%"
            extra={
                <Space>
                    <div className='Hover-Refresh2 back-hover1 able-style'
                        role="button"
                        tabIndex={0} title='Close'
                        onClick={() => openTacking()}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                openTacking()
                            }
                        }}
                        aria-label='Close'
                    > <CancelIcon width={24} height={24} /></div>
                </Space>
            }
            footer={false}
        >
            <CustomHtmlParser html={researchContent?.accountIntelligenceReport} key={1} />
        </Drawer>
        </>
    );
};
NoteDetails.propTypes = {
    openIntelligence: PropTypes.bool.isRequired,
    openTacking: PropTypes.func.isRequired,
    researchContent: PropTypes.object.isRequired,
};
export default NoteDetails;